
import React, { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import ReactPaginate from "react-paginate";
import { useLocation, Link, useHistory } from "react-router-dom";
import DatePicker from "react-datepicker";
import Loader from "react-js-loader";
import Swal from "sweetalert2";
import admindata from "../../components/admindata";
import { DateObject } from "react-multi-date-picker";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { apiRequest } from "../../apiServices/allApi";
import { BiEditAlt } from "react-icons/bi";
import { toast } from "react-toastify";
// import './ViewUser.css';

const $ = require("jquery");
$.Datatable = require("datatables.net");

export default function View(props) {
  const history = useHistory()
  const access_token = localStorage.getItem("token");
  const [user1, setUser1] = useState();

  const getUser1 = async () => {
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest("admin/me_data", "GET", null, headers)
      setUser1(res.data);
      console.log(res);
    } catch (e) {
      if (e.response && e.response.status == 401) {
        localStorage.removeItem("token");
        history.push("/adminlogin")
      }
    }
  }

  useEffect(() => {
    getUser1();
  }, []);

  const [loading, setLoading] = useState(false);
  const navigate = useHistory();
  const location = useLocation();
  const path = location.pathname.split("/")[3];
  const [user, setUser] = useState();
  const [item, setVerify] = useState();
  const [challenge, setchallenge] = useState();
  const [txn, setTxn] = useState();
  const [txnwith, setTxnwith] = useState();
  const [referral, setReferral] = useState();
  const [bonus, setBonus] = useState();
  const [penalty, setPenalty] = useState();
  const [kyc, setKyc] = useState();
  const [merged, setMerged] = useState([]);
  let [mismatchValue, setmismatchValue] = useState(0);
  let [HoldBalance, setHoldBalance] = useState(0);
  const [referCount, setRefercount] = useState([]);

  const [values, setValues] = useState([
    new DateObject().subtract(4, "days"),
    new DateObject().add(4, "days"),
  ]);

  let [limit, setLimit] = useState(20);

  const setpageLimit = (event) => {
    let key = event.target.value;
    setLimit(key);
  };
  const [pageNumber, setPageNumber] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(0);

  const [searchList, setSearchList] = useState(0);
  const [searchType, setSearchType] = useState(0);
  const [findByStatus, setFindByStatus] = useState(0);

  const searchHandler = (event) => {
    let key = event.target.value;
    setSearchList(key);
  };

  const searchByStatus = (event) => {
    let key = event.target.value;
    setFindByStatus(key);
  };

  const handlePageClick = async (data) => {
    let currentPage = data.selected + 1;
  };

  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const getUser = async () => {
    setLoading(true);
    let access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`admin/get_user_data/${path}`, "GET", null, headers);
      setLoading(false);
      console.log(res.data);
      setUser(res.data);
      Allrefer(res.data.referral_code);
      setmismatchValue(
        res.data.Wallet_balance -
        (res.data.wonAmount -
          res.data.loseAmount +
          res.data.totalDeposit +
          res.data.referral_earning +
          res.data.totalBonus -
          (res.data.totalWithdrawl +
            res.data.referral_wallet +
            res.data.withdraw_holdbalance +
            res.data.hold_balance +
            res.data.totalPenalty))
      );
      setHoldBalance(res.data.hold_balance);
    } catch (error) {
      setLoading(false);
    }
  };

  const Allrefer = async (id) => {
    setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`admin/referral_code/${id}`, "GET", null, headers);
      setRefercount(res.data);
      console.log(res.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const Allchallenge = async () => {
    setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`get_challange/user/${path}`, "GET", null, headers);
      setLoading(false);
      setTxn(undefined);
      setTxnwith(undefined);
      setReferral(undefined);
      setBonus(undefined);
      setPenalty(undefined);
      setKyc(undefined);
      setMerged(undefined);
      setchallenge(res.data);
      $("table").dataTable();
    } catch (error) {
      setLoading(false);
    }
  };

  const transactionHis = async () => {
    setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`admin/txn_history_admin/user/${path}`, "GET", null, headers);
      setLoading(false);
      setchallenge(undefined);
      setReferral(undefined);
      setBonus(undefined);
      setPenalty(undefined);
      setKyc(undefined);
      setTxnwith(undefined);
      setMerged(undefined);
      setTxn(res.data);
      $("table").dataTable();
    } catch (error) {
      setLoading(false);
    }
  };

  const withdrawalHis = async () => {
    setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`admin/txnwith_history_user/admin/${path}`, "GET", null, headers);
      setLoading(false);
      setTxn(undefined);
      setchallenge(undefined);
      setReferral(undefined);
      setBonus(undefined);
      setPenalty(undefined);
      setKyc(undefined);
      setMerged(undefined);
      setTxnwith(res.data);
      $("table").dataTable();
    } catch (error) {
      setLoading(false);
    }
  };

  const dateFormat = (e) => {
    const date = new Date(e);
    const newDate = date.toLocaleString("default", {
      month: "long",
      day: "numeric",
      hour: "numeric",
      hour24: true,
      minute: "numeric",
    });
    return newDate;
  };

  const referralHis = async () => {
    setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`admin/referral_admin_history/code/winn/${user.referral_code}`, "GET", null, headers);
      setLoading(false);
      setchallenge(undefined);
      setTxn(undefined);
      setTxnwith(undefined);
      setKyc(undefined);
      setMerged(undefined);
      setBonus(undefined);
      setPenalty(undefined);
      setReferral(res.data);
      $("table").dataTable();
    } catch (error) {
      setLoading(false);
    }
  };

  const bonusHis = async () => {
    setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`admin/bonus_history_admin/user/${user.id}`, "GET", null, headers);
      setLoading(false);
      setchallenge(undefined);
      setTxn(undefined);
      setTxnwith(undefined);
      setKyc(undefined);
      setMerged(undefined);
      setPenalty(undefined);
      setBonus(res.data);
      setReferral(undefined);
      $("table").dataTable();
    } catch (error) {
      setLoading(false);
    }
  };

  const penaltyHis = async () => {
    setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`admin/penalty_history_admin/user/${user.id}`, "GET", null, headers);
      setLoading(false);
      setchallenge(undefined);
      setTxn(undefined);
      setTxnwith(undefined);
      setKyc(undefined);
      setMerged(undefined);
      setPenalty(res.data);
      setBonus(undefined);
      setReferral(undefined);
      $("table").dataTable();
    } catch (error) {
      setLoading(false);
    }
  };

  const getKyc = async () => {
    setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`admin/user/kyc/${path}`, "GET", null, headers);
      setLoading(false);
      setTxn(undefined);
      setTxnwith(undefined);
      setReferral(undefined);
      setBonus(undefined);
      setPenalty(undefined);
      setchallenge(undefined);
      setKyc(res.data);
      setMerged(undefined);
      $("table").dataTable();
      imageViewer();
    } catch (error) {
      setLoading(false);
    }
  };

  const all_history = () => {
    navigate.push(`/user/allhistory/${path}`);
  };

  function imageViewer() {
    let imgs = document.getElementsByClassName("img"),
      out = document.getElementsByClassName("img-out")[0];
    for (let i = 0; i < imgs.length; i++) {
      if (!imgs[i].classList.contains("el")) {
        imgs[i].classList.add("el");
        imgs[i].addEventListener("click", lightImage);
        function lightImage() {
          let container = document.getElementsByClassName("img-panel")[i];
          container.classList.toggle("img-panel__selct");
        }

        imgs[i].addEventListener("click", openImage);
        function openImage() {
          let imgElement = document.createElement("img"),
            imgWrapper = document.createElement("div"),
            imgClose = document.createElement("div"),
            container = document.getElementsByClassName("img-panel")[i];
          container.classList.add("img-panel__selct");
          imgElement.setAttribute("class", "image__selected");
          imgElement.src = imgs[i].src;
          imgWrapper.setAttribute("class", "img-wrapper");
          imgClose.setAttribute("class", "img-close");
          imgWrapper.appendChild(imgElement);
          imgWrapper.appendChild(imgClose);

          setTimeout(function () {
            imgWrapper.classList.add("img-wrapper__initial");
            imgElement.classList.add("img-selected-initial");
          }, 50);

          out.appendChild(imgWrapper);
          imgClose.addEventListener("click", function () {
            container.classList.remove("img-panel__selct");
            out.removeChild(imgWrapper);
          });
        }
      }
    }
  }

  const update = async (Id) => {
    setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`aadharcard/${Id}`, "PATCH", { verified: "verified" }, headers)
      setLoading(false);
      getUser();
      getKyc();
    } catch (error) {
      setLoading(false);
    }
  };

  const handleDelete = async (Id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    if (window.confirm("Are you sure you want to delete?")) {
      try {
        const res = await apiRequest(`aadharcard/${Id}`, "DELETE", {}, headers)
        getKyc();
        getUser();
      } catch (error) {
      }
    }
  };

  const updateMismatch = async (Id) => {
    setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`admin/admin_user/missmatch/clear/${Id}`, "PATCH", null, headers)
      setLoading(false);
      getUser();
      alert("Updated Successfully");
    } catch (error) {
      setLoading(false);
    }
  };

  const updateHold = async (Id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(`admin/admin_user/Hold/clear/${Id}`, "PATCH", null, headers)
      getUser();
      alert("Updated Successfully");
    } catch (error) {
    }
  };

  const checkfailedpayout = (txn_id, referenceId) => {
    setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    axios
      .post(
        baseUrl + `payout/response/api`,
        { txn_id, referenceId },
        { headers }
      )
      .then((res) => {
        setLoading(false);
        const icon = res.data.status == "SUCCESS" ? "success" : "danger";
        const title =
          res.data.status == "SUCCESS"
            ? "Withdraw successfully"
            : "Transaction Processing or Failed";
        getUser();
        withdrawalHis();
        alert(title);
      })
      .catch((e) => {
        setLoading(false);
        if (e.response && e.response.status == 401) {
          localStorage.removeItem("token");
          window.location.reload();
        }
      });
  };

  const deletedata = async (Id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(`aadharcard/${Id}`, "PATCH", { verified: "reject" }, headers)
      getUser();
      getKyc();
    } catch (error) {
    }
  };

  const Referal = () => {
    const access_token = localStorage.getItem('token');
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    Swal.fire({
      title: "Enter Referral code",
      inputValue: user.referral,
      input: "number",
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: true,
      confirmButtonText: "Submit",
      showLoaderOnConfirm: true,
      preConfirm: async (login) => {
        try {
          const res = await apiRequest(`admin/user_update_refferal/${login ? login : "referral"}/${path}`, "GET", null, headers)
          if (res.data) {
            Swal.fire({
              title: `${res.data?.msg}`,
            });
            getUser();
          }
        } catch (e) {
          Swal.showValidationMessage(`Request failed: ${e.data?.msg}`);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    })
  };

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  function RefferalUser(id) {
    navigate.push(`/user/view_user/${id}`)
    handleClose()
    window.location.reload();
  }

  useEffect(() => {
    getUser();
    Allchallenge();
    getKyc();
  }, []);

  useEffect(() => {
    setMerged(null);
  }, []);

  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
  const handleDeleteBankDetails = async (userId) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this user's bank details?"
    );

    if (!confirmDelete) return;

    try {
      const token = localStorage.getItem("token");

      const res = await apiRequest(
        "user/profile/delete-bank-details",
        "PATCH",
        {
          userId: userId,
        },
        {
          Authorization: `Bearer ${token}`,
        }
      );

      console.log("Delete bank response:", res);

      if (res?.status) {
        toast.success("Bank details deleted successfully");

        // User detail refresh
        getUser();
      } else {
        toast.error(res?.msg || "Unable to delete bank details");
      }

    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    }
  };
  return loading ? (
    <div className="App">
      <div className="item dashboaed_loader">
        <Loader
          type="bubble-ping"
          bgColor={"#fff"}
          title={"Loading Please Wait"}
          color={"#FFFFFF"}
          size={100}
        />
      </div>
    </div>
  ) : (
    <div className="user-view-container">
      {Boolean(user) && (
        <>
          <div className="img-out"></div>

          {/* User Details Grid */}
          <div className="row g-4 mb-4">
            <div className="col-lg-6">
              <div className="user-info-card">
                <div className="user-card-header">User Details</div>
                <ul className="user-detail-list">
                  {user && user.avatar && (
                    <li className="user-detail-item img-panel">
                      <span className="detail-label">Profile Pic</span>
                      <img
                        className="img"
                        src={baseUrl + `/${user.avatar}`}
                        alt="Profile"
                        style={{
                          borderRadius: "8px",
                          width: "3.5rem",
                          height: "3.5rem",
                          objectFit: "cover"
                        }}
                      />
                    </li>
                  )}
                  <li className="user-detail-item">
                    <span className="detail-label">Name</span>
                    <span className="detail-value">{user.Name}</span>
                  </li>

                  <li className="user-detail-item">
                    <span className="detail-label">Verification</span>
                    <span className={`badge-status ${user.verified == "verified" ? "badge-verified" : "badge-rejected"}`}>
                      {user.verified}
                    </span>
                  </li>

                  <li className="user-detail-item">
                    <span className="detail-label">Phone</span>
                    {admindata?.user?.usertype == "Admin" || admindata?.user?.updateLegalData === true ? (
                      <a
                        href={`https://wa.me/91${user.Phone}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: 'none', color: '#34d399', fontWeight: 700 }}
                      >
                        {user.Phone}
                      </a>
                    ) : (
                      <span className="detail-value">
                        {'********' + user.Phone.toString().slice(-2)}
                      </span>
                    )}
                  </li>

                  <li className="user-detail-item">
                    <span className="detail-label">Email</span>
                    <span className="detail-value">{isValidEmail(user.Email) ? user.Email : 'N/A'}</span>
                  </li>

                  <li className="user-detail-item">
                    <span className="detail-label">Wallet Balance</span>
                    <span className="detail-value" style={{ color: '#34d399' }}>₹{user.Wallet_balance}</span>
                  </li>

                  <li className="user-detail-item">
                    <span className="detail-label">Withdrawal Balance</span>
                    <span className="detail-value">₹{user.withdrawAmount}</span>
                  </li>

                  <li className="user-detail-item">
                    <span className="detail-label">Withdrawal Hold</span>
                    <div className="text-end">
                      <span className="detail-value" style={{ color: '#fb923c' }}>₹{user.withdraw_holdbalance}</span>
                      <div style={{ fontSize: '0.75rem', color: '#94a3b8' }}>Hold must be 0 to withdraw</div>
                    </div>
                  </li>

                  <li className="user-detail-item">
                    <span className="detail-label">Referral Balance</span>
                    <span className="detail-value">₹{user.referral_wallet}</span>
                  </li>

                  <li className="user-detail-item">
                    <span className="detail-label">Referral Count</span>
                    <span className="detail-value">{referCount || 0}</span>
                  </li>

                  <li className="user-detail-item">
                    <span className="detail-label">Referral Earning</span>
                    <span className="detail-value">₹{user.referral_earning}</span>
                  </li>

                  <li className="user-detail-item">
                    <span className="detail-label">Total Deposit</span>
                    <span className="detail-value">₹{user.totalDeposit}</span>
                  </li>

                  <li className="user-detail-item">
                    <span className="detail-label">Total Withdrawal</span>
                    <span className="detail-value">₹{user.totalWithdrawl}</span>
                  </li>

                  <li className="user-detail-item">
                    <span className="detail-label">Total Bonus</span>
                    <span className="detail-value">₹{user.totalBonus}</span>
                  </li>

                  <li className="user-detail-item">
                    <span className="detail-label">Total Penalty</span>
                    <span className="detail-value" style={{ color: '#f87171' }}>₹{user.totalPenalty}</span>
                  </li>

                  <li className="user-detail-item">
                    <span className="detail-label">Game Hold Balance</span>
                    <span className="detail-value">₹{HoldBalance}</span>
                  </li>

                  <li className="user-detail-item">
                    <span className="detail-label">Won Amount</span>
                    <span className="detail-value" style={{ color: '#34d399' }}>₹{user.wonAmount}</span>
                  </li>

                  <li className="user-detail-item">
                    <span className="detail-label">Lose Amount</span>
                    <span className="detail-value" style={{ color: '#f87171' }}>₹{user.loseAmount}</span>
                  </li>

                  <li className="user-detail-item">
                    <span className="detail-label">Calculated Wallet</span>
                    <span className="detail-value">
                      ₹{user.wonAmount -
                        user.loseAmount +
                        user.totalDeposit +
                        user.referral_earning +
                        user.totalBonus -
                        (user.totalWithdrawl +
                          user.referral_wallet +
                          user.withdraw_holdbalance +
                          user.hold_balance +
                          user.totalPenalty)}
                    </span>
                  </li>

                  <li className="user-detail-item">
                    <span className="detail-label">Mismatch Balance</span>
                    <span className="detail-value" style={{ color: mismatchValue !== 0 ? '#f87171' : '#34d399' }}>
                      ₹{mismatchValue}
                    </span>
                  </li>

                  <li className="user-detail-item">
                    <span className="detail-label">Referral Code</span>
                    <span className="detail-value d-flex align-items-center gap-2">
                      {user.referral_code}
                      <RemoveRedEyeIcon style={{ cursor: 'pointer', color: '#38bdf8' }} onClick={handleShow} />
                    </span>
                  </li>

                  <li className="user-detail-item">
                    <span className="detail-label">Referred By</span>
                    <span className="detail-value d-flex align-items-center gap-2">
                      {user.referral}
                      {user1?.user_type === 'Admin' && (
                        <BiEditAlt style={{ cursor: 'pointer', color: '#a5b4fc' }} onClick={Referal} />
                      )}
                    </span>
                  </li>

                  <li className="user-detail-item">
                    <span className="detail-label">Created At</span>
                    <span className="detail-value">{dateFormat(user.createdAt).split(",")[0]}</span>
                  </li>

                  <li className="user-detail-item">
                    <span className="detail-label">Updated At</span>
                    <span className="detail-value">{dateFormat(user.updatedAt).split(",")[0]}</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Bank Details Grid */}
            <div className="col-lg-6">
              <div className="user-info-card">
                <div className="user-card-header">Bank Details</div>
                <button
                  type="button"
                  className="delete-bank-btn"
                  onClick={() => handleDeleteBankDetails(user._id)}
                >
                  DELETE BANK DETAILS
                </button>
                <ul className="user-detail-list">
                  <li className="user-detail-item">
                    <span className="detail-label">Account Holder Name</span>
                    <span className="detail-value">{user.holder_name || 'N/A'}</span>
                  </li>
                  <li className="user-detail-item">
                    <span className="detail-label">IFSC Code</span>
                    <span className="detail-value">{user.ifsc_code || 'N/A'}</span>
                  </li>
                  <li className="user-detail-item">
                    <span className="detail-label">Account Number</span>
                    <span className="detail-value">{user.account_number || 'N/A'}</span>
                  </li>
                  <li className="user-detail-item">
                    <span className="detail-label">UPI ID</span>
                    <span className="detail-value" style={{ color: '#38bdf8' }}>{user.upi_id || 'N/A'}</span>
                  </li>
                  <li className="user-detail-item">
                    <span className="detail-label">Clear Mismatch</span>
                    <button onClick={() => updateMismatch(user._id)} className="btn-action-small btn-action-clear">
                      CLEAR ({mismatchValue})
                    </button>
                  </li>
                  <li className="user-detail-item">
                    <span className="detail-label">Clear Hold Balance</span>
                    <button onClick={() => updateHold(user._id)} className="btn-action-small btn-action-clear">
                      CLEAR ({HoldBalance})
                    </button>
                  </li>
                  <li className="user-detail-item">
                    <span className="detail-label">Account Status</span>
                    {user.user_type === "Block" ? (
                      <div className="text-end">
                        <span className="badge-status badge-rejected">Blocked</span>
                        <div style={{ fontSize: '0.75rem', color: '#f87171', marginTop: '4px' }}>
                          Reason: {user.lastmsg}
                        </div>
                      </div>
                    ) : (
                      <span className="badge-status badge-verified">Active</span>
                    )}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Tab Controls Bar */}
          <div className="tab-navigation-bar">
            <button className={`btn-nav-tab ${Boolean(challenge) ? 'active' : ''}`} onClick={Allchallenge}>
              Game History
            </button>
            <button className={`btn-nav-tab ${Boolean(txn) ? 'active' : ''}`} onClick={transactionHis}>
              Deposit History
            </button>
            <button className={`btn-nav-tab ${Boolean(txnwith) ? 'active' : ''}`} onClick={withdrawalHis}>
              Withdrawal History
            </button>
            <button className={`btn-nav-tab ${Boolean(referral) ? 'active' : ''}`} onClick={referralHis}>
              Referral History
            </button>
            <button className={`btn-nav-tab ${Boolean(bonus) ? 'active' : ''}`} onClick={bonusHis}>
              Bonus History
            </button>
            <button className={`btn-nav-tab ${Boolean(penalty) ? 'active' : ''}`} onClick={penaltyHis}>
              Penalty History
            </button>
            <button className={`btn-nav-tab ${Boolean(kyc) ? 'active' : ''}`} onClick={getKyc}>
              KYC Documents
            </button>
            <button className="btn-nav-history ms-auto" onClick={all_history}>
              All History
            </button>
          </div>

          {/* Tables Rendering Section */}
          {Boolean(challenge) && (
            <div className="table-responsive-wrapper mb-4">
              <table className="view-modern-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>ID</th>
                    <th>Creator</th>
                    <th>Accepter</th>
                    <th>Amount</th>
                    <th>Win/Lose Amt</th>
                    <th>Closing Balance</th>
                    <th>Status</th>
                    <th>Game Type</th>
                    <th>Winner</th>
                    <th>Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {challenge && challenge.map((game, key) => (
                    <tr key={key}>
                      <td>{key + 1}</td>
                      <td style={{ fontFamily: 'monospace', color: '#a5b4fc' }}>{game?._id || 'N/A'}</td>
                      <td>{game.Created_by ? game.Created_by.Name : 'N/A'}</td>
                      <td>{game.Accepetd_By ? game.Accepetd_By.Name : 'N/A'}</td>
                      <td style={{ fontWeight: 700 }}>₹{game.Game_Ammount}</td>
                      <td style={{ fontWeight: 700, color: game.Winner && user?._id == game.Winner?._id ? '#34d399' : '#f87171' }}>
                        {game.Winner
                          ? user?._id == game.Winner?._id
                            ? "+" + game.winnAmount
                            : "-" + game.Game_Ammount
                          : user?._id == game.Created_by?._id
                            ? game.winnAmount
                            : "-" + game.winnAmount}
                      </td>
                      <td>
                        ₹{game.Winner
                          ? user?._id == game.Winner?._id
                            ? game.Winner_closingbalance
                            : game.Loser_closingbalance
                          : user?._id == game.Created_by?._id
                            ? game.Loser_closingbalance
                            : game.Winner_closingbalance}
                      </td>
                      <td style={{ fontWeight: 700, color: '#38bdf8' }}>{game.Status}</td>
                      <td>{game.Game_type}</td>
                      <td>{game.Winner ? game.Winner.Name : 'N/A'}</td>
                      <td>{moment(game.updatedAt).format("MMMM Do YYYY, h:mm:ss a")}</td>
                      <td>
                        <Link className="btn btn-sm btn-primary" to={`/view/${game._id}`}>
                          View
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {Boolean(txn) && (
            <div className="table-responsive-wrapper mb-4">
              <table className="view-modern-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>ID</th>
                    <th>Amount</th>
                    <th>Closing Balance</th>
                    <th>Status</th>
                    <th>Payment Gateway</th>
                    <th>Created At</th>
                    <th>Updated At</th>
                  </tr>
                </thead>
                <tbody>
                  {txn.map((data, key) => (
                    <tr key={key}>
                      <td>{key + 1}</td>
                      <td style={{ fontFamily: 'monospace', color: '#a5b4fc' }}>{data._id}</td>
                      <td style={{ fontWeight: 700, color: '#34d399' }}>₹{data.amount}</td>
                      <td>₹{data.closing_balance}</td>
                      <td style={{ fontWeight: 700, color: '#34d399' }}>{data.status}</td>
                      <td>{data.payment_gatway || "N/A"}</td>
                      <td>{moment(data.createdAt).format("MMMM D [at] h:mm A")}</td>
                      <td>{moment(data.updatedAt).format("MMMM D [at] h:mm A")}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {Boolean(txnwith) && (
            <div className="table-responsive-wrapper mb-4">
              <table className="view-modern-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>ID</th>
                    <th>Type</th>
                    <th>Amount</th>
                    <th>Closing Balance</th>
                    <th>UPI</th>
                    <th>Status</th>
                    <th>Action</th>
                    <th>Created At</th>
                    <th>Updated At</th>
                  </tr>
                </thead>
                <tbody>
                  {txnwith && txnwith.map((data, key) => (
                    <tr key={key}>
                      <td>{key + 1}</td>
                      <td style={{ fontFamily: 'monospace', color: '#a5b4fc' }}>{data._id}</td>
                      <td>{data.Withdraw_type}</td>
                      <td style={{ fontWeight: 700, color: '#fb923c' }}>₹{data.amount}</td>
                      <td>₹{data.closing_balance}</td>
                      <td>{data.upiId}</td>
                      <td style={{ fontWeight: 700, color: '#34d399' }}>{data.status}</td>
                      <td>
                        {data.status != "SUCCESS" && data.amount == user.withdraw_holdbalance ? (
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => checkfailedpayout(data._id, data.referenceId)}
                          >
                            Check {data.payment_gatway}
                          </button>
                        ) : (
                          "Checked"
                        )}
                      </td>
                      <td>{moment(data.createdAt).format("MMMM D [at] h:mm A")}</td>
                      <td>{moment(data.updatedAt).format("MMMM D [at] h:mm A")}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {Boolean(referral) && (
            <div className="table-responsive-wrapper mb-4">
              <table className="view-modern-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>ID</th>
                    <th>Earned By</th>
                    <th>Amount</th>
                    <th>Closing Balance</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {referral?.map((data, key) => (
                    <tr key={key}>
                      <td>{key + 1}</td>
                      <td style={{ fontFamily: 'monospace', color: '#a5b4fc' }}>{data._id}</td>
                      <td>{data.earned_from ? data.earned_from.Name : 'N/A'}</td>
                      <td style={{ fontWeight: 700, color: '#34d399' }}>₹{data.amount}</td>
                      <td>₹{data.closing_balance}</td>
                      <td>{moment(data.updatedAt).format("MMMM Do YYYY, h:mm:ss a")}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {Boolean(kyc) && (
            <div className="table-responsive-wrapper mb-4">
              <table className="view-modern-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>ID</th>
                    <th>Doc Name</th>
                    <th>Document No</th>
                    <th>Address</th>
                    <th>DOB</th>
                    <th>Document-Front</th>
                    <th>Document-Back</th>
                    <th>Status</th>
                    <th>Date</th>
                    <th>Approve or Reject</th>
                  </tr>
                </thead>
                <tbody>
                  {kyc && kyc.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td style={{ fontFamily: 'monospace', color: '#a5b4fc' }}>{item._id}</td>
                      <td>{item.Name}</td>
                      <td style={{ fontFamily: 'monospace', color: '#38bdf8' }}>{item.Number}</td>
                      <td>{item.Address ? item.Address.replace(/<br>/g, '').slice(0, 150) : ''}</td>
                      <td>{item.DOB}</td>
                      <td>
                        <div className="img-panel">
                          <img
                            className="img"
                            src={baseUrl + `/${item.front}`}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1200px-No-Image-Placeholder.svg.png';
                            }}
                            alt="kyc"
                            style={{ borderRadius: "6px", width: "3.5rem", height: "3.5rem", objectFit: "cover" }}
                            id={`kyc${index}`}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="img-panel">
                          <img
                            className="img"
                            src={baseUrl + `/${item.back}`}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1200px-No-Image-Placeholder.svg.png';
                            }}
                            alt="kyc"
                            style={{ borderRadius: "6px", width: "3.5rem", height: "3.5rem", objectFit: "cover" }}
                            id={`kyc${index}`}
                          />
                        </div>
                      </td>
                      <td>
                        <span className={`badge-status ${item.verified === "reject" ? "badge-rejected" : "badge-verified"}`}>
                          {item.verified}
                        </span>
                      </td>
                      <td>{moment(item?.updatedAt).format("MMMM Do YYYY, h:mm:ss a")}</td>
                      <td>
                        <div className="d-flex gap-1">
                          <button
                            className="btn btn-sm btn-success"
                            disabled={item.verified === "verified"}
                            onClick={() => update(item._id)}
                          >
                            Approve
                          </button>
                          <button
                            className="btn btn-sm btn-warning"
                            onClick={() => deletedata(item._id)}
                          >
                            Reject
                          </button>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => handleDelete(item._id)}
                          >
                            Force Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {Boolean(bonus) && (
            <div className="table-responsive-wrapper mb-4">
              <table className="view-modern-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>ID</th>
                    <th>Amount</th>
                    <th>Closing Balance</th>
                    <th>Reason</th>
                    <th>Status</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {bonus.map((data, key) => (
                    <tr key={key}>
                      <td>{key + 1}</td>
                      <td style={{ fontFamily: 'monospace', color: '#a5b4fc' }}>{data._id}</td>
                      <td style={{ fontWeight: 700, color: '#34d399' }}>₹{data.amount}</td>
                      <td>₹{data.closing_balance}</td>
                      <td>{data.txn_msg}</td>
                      <td style={{ fontWeight: 700, color: '#34d399' }}>{data.status}</td>
                      <td>{moment(data.updatedAt).format("MMMM Do YYYY, h:mm:ss a")}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {Boolean(penalty) && (
            <div className="table-responsive-wrapper mb-4">
              <table className="view-modern-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>ID</th>
                    <th>Amount</th>
                    <th>Closing Balance</th>
                    <th>Reason</th>
                    <th>Status</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {penalty.map((data, key) => (
                    <tr key={key}>
                      <td>{key + 1}</td>
                      <td style={{ fontFamily: 'monospace', color: '#a5b4fc' }}>{data._id}</td>
                      <td style={{ fontWeight: 700, color: '#f87171' }}>₹{data.amount}</td>
                      <td>₹{data.closing_balance}</td>
                      <td>{data.txn_msg}</td>
                      <td style={{ fontWeight: 700, color: '#f87171' }}>{data.status}</td>
                      <td>{moment(data.updatedAt).format("MMMM Do YYYY, h:mm:ss a")}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}

      {/* Referral Modal */}
      <Modal show={show} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title style={{ color: '#fff', fontFamily: 'Outfit' }}>Referral History</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive-wrapper">
            <table className="view-modern-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Number</th>
                </tr>
              </thead>
              <tbody>
                {user && user?.referral_user?.map((data, key) => (
                  <tr key={key}>
                    <td>{key + 1}</td>
                    <td>
                      <span
                        className="badge-status badge-verified"
                        style={{ cursor: "pointer" }}
                        onClick={() => RefferalUser(data.id)}
                      >
                        {data.Name}
                      </span>
                    </td>
                    <td>
                      {admindata?.user?.usertype == 'Admin' || admindata?.user?.updateLegalData === true ? (
                        <span style={{ color: '#34d399', fontWeight: 600 }}>{data.Phone}</span>
                      ) : (
                        <span style={{ color: '#94a3b8' }}>
                          {'********' + data.Phone.toString().slice(-2)}
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}